import { UserRole, UserStatus } from 'src/Redux/api/usersApi.ts'

export const roleLabels: Record<UserRole, string> = {
  [UserRole.SALES]: 'Менеджер',
  [UserRole.LEAD_MANAGER]: 'Руководитель',
  [UserRole.ADMIN]: 'Администратор',
}

export const statusLabels: Record<UserStatus, string> = {
  [UserStatus.ACTIVE]: 'Активен',
  [UserStatus.ARCHIVED]: 'В архиве',
}

export const assignableRoleOptions = [
  { value: UserRole.SALES, label: roleLabels[UserRole.SALES] },
  { value: UserRole.LEAD_MANAGER, label: roleLabels[UserRole.LEAD_MANAGER] },
]

export const roleFilterOptions = [
  { value: '', label: 'Все роли' },
  ...assignableRoleOptions,
  { value: UserRole.ADMIN, label: roleLabels[UserRole.ADMIN] },
]
